/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_ExpandInputs */



/**
* | output |
* | --- |
* | "Expand" |
*
* @param {Shortcut_Keys_Name_ExpandInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_expand = /** @type {((inputs?: Shortcut_Keys_Name_ExpandInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_ExpandInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Etendre")
	if (locale === "de") return /** @type {LocalizedString} */ ("Expandieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Espandere")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Расширять")
	if (locale === "es") return /** @type {LocalizedString} */ ("Expandir")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("扩张")
	if (locale === "ja") return /** @type {LocalizedString} */ ("拡大する")
	if (locale === "hi") return /** @type {LocalizedString} */ ("बढ़ाना")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Expandir")
	return /** @type {LocalizedString} */ ("Expand")
});